import './index.css'
import './i18n'
import './lib/utils/strMethods'

import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { SnackbarProvider } from 'notistack'
import { ThemeProvider, CssBaseline, createTheme } from '@mui/material'
import { AuthStoreProvider } from 'context/AuthStore'
import { asterTheme } from 'asterX-UI'
import { ModalbarProvider } from 'lib/modules/Modalbar'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { ru } from 'date-fns/locale'
import { ruRU } from '@mui/x-date-pickers/locales'

import App from './App'

const root = ReactDOM.createRoot(document.getElementById('root'))

const asterThemeWithLocale = createTheme(asterTheme, ruRU)

root.render(
  <ThemeProvider theme={asterThemeWithLocale}>
    <CssBaseline />
    <BrowserRouter>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ru}>
        <SnackbarProvider
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center'
          }}
          autoHideDuration={3000}
        >
          <ModalbarProvider>
            <AuthStoreProvider>
              <App />
            </AuthStoreProvider>
          </ModalbarProvider>
        </SnackbarProvider>
      </LocalizationProvider>
    </BrowserRouter>
  </ThemeProvider>
)
